<template>
    <div class="breadcrumb">
        <div class="item mobileMenuButton" v-if="menuMobile">
            <feather type="menu" @click="showMenu()" />
        </div>
        <div class="item pagetitle">
            {{ $route.meta.pageTitle }}
        </div>
        <div class="item">
            <router-link to="/"> <feather type="home"/></router-link>
            <span class="separator"><feather type="chevrons-right"/></span>
        </div>
        <div class="item" v-for="(link, index) in $route.meta.breadcrumb.slice(1,-1)" :key="index">
            <router-link :to="link.url" v-if="link.url">{{ link.title }}</router-link>
            <span v-else>{{ link.title }}</span>
            <span class="separator"><feather type="chevrons-right"/></span>
        </div>
        <div class="item">
            <span v-if="$route.meta.breadcrumb.slice(-1)[0].active">{{ $route.meta.breadcrumb.slice(-1)[0].title }}</span>
        </div>
        <div class="logo-company">
            <!-- <img :src="currentCompany.image" alt="Logo" class="logo" v-if="currentCompany.image !== ''"> -->
            <img src="@/assets/images/logo.png" alt="Logo" class="logo">
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name: 'Header-Breadcrumb',
    computed: {
      windowWidth () { return this.$store.state.windowWidth },
      menuMobile () { return this.$store.state.menuMobile },
      statusMenu () { return this.$store.state.navMenuActive },
      currentCompany () { return this.$store.state.companyInfoData; }
    },
    methods: {
      ...mapActions([
        'showMenuMobile',
        'updatedMenuActive'
      ]),
      showMenu(){
        this.updatedMenuActive(!this.statusMenu)
      }
    }
}
</script>
